import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useHttpClient } from 'hooks/http-hook';
import { useAuth } from "providers/AuthProvider";

const R2Context = createContext({
  mainNavOpen: false,
  setMainNavOpen: () => {},
  toggleMainNav: () => {},
  userCreatedPages: [],
});

export const R2Provider = ({ children }) => {
  const { token } = useAuth();
  const { sendRequest } = useHttpClient();
  const [mainNavOpen, setMainNavOpen] = useState(false);
  const [userCreatedPages, setUserCreatedPages] = useState([]);

  const toggleMainNav = useCallback(() => {
    setMainNavOpen((prev) => !prev);
  }, []);

  // Get user created pages to load into mainNav.
  useEffect(() => {
    const getPages = async () => {
      try {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/pages`, 'GET', null, { Authorization: `Bearer ${token}` });
        setUserCreatedPages(response.pages);
      } catch (err) {
        console.error(err);
      }
    }
    if (token) getPages();
  }, [token, sendRequest]);

  return (
    <R2Context.Provider value={{ mainNavOpen, setMainNavOpen, toggleMainNav, userCreatedPages }}>
      {children}
    </R2Context.Provider>
  );
};

export const useR2 = () => useContext(R2Context);